import {areIntervalsOverlapping} from 'date-fns';
import {ProcessedMeetingRoomEvent} from '@shared/core';

export const getLimitEndTime = (startDate: Date, evs: ProcessedMeetingRoomEvent[]) => {
  const event = evs.find((event) => {
    return startDate < event.start;
  });

  if (!event) return null;

  return event.start;
};

export const checkTimeIsInInterval = (date: Date, evs: ProcessedMeetingRoomEvent[]) => {
  return (
    evs &&
    evs.some((ev) => {
      return date >= ev.start && date < ev.end;
    })
  );
};

export const checkEventsIsOverlapping = (newEvent: ProcessedMeetingRoomEvent, evs: ProcessedMeetingRoomEvent[]) => {
  return evs.some((event) => {
    return areIntervalsOverlapping(newEvent, event);
  });
};
